// @ts-strict-ignore
import { useState } from 'react';
import { fetchBuildDistributionExternalBuild } from '../../api';
import { FetchExternalBuildDistroBuildResponse } from '@/types';

export type GetExternalBuildHookResult = [
    getExternalBuild: (buildHash: string, bucketHash: string) => Promise<FetchExternalBuildDistroBuildResponse>,
    isLoading: boolean,
    error: any,
];

export function useGetExternalBuildDistroBuild(): GetExternalBuildHookResult {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getExternalBuildFn = async (buildHash: string, bucketHash: string) => {
        setIsLoading(true);
        try {
            const build = await fetchBuildDistributionExternalBuild({ buildHash, bucketHash });

            return build;
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }

        return null;
    };

    return [getExternalBuildFn, isLoading, error];
}
